"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RoleProvider = void 0;

var _react = _interopRequireDefault(require("react"));

var _client = require("@apollo/client");

var _LoadingOutlined = _interopRequireDefault(require("@ant-design/icons/LoadingOutlined"));

var _spin = _interopRequireDefault(require("antd/lib/spin"));

var _role = require("./gqls/role");

// import
// graphql import
// definition
var RoleContext = /*#__PURE__*/_react["default"].createContext('GUEST');

var RoleProvider = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var _data$viewer;

  var children = _ref.children;

  var _useQuery = (0, _client.useQuery)(_role.getRole),
      data = _useQuery.data;

  var role = data === null || data === void 0 ? void 0 : (_data$viewer = data.viewer) === null || _data$viewer === void 0 ? void 0 : _data$viewer.role;
  if (!role) return /*#__PURE__*/_react["default"].createElement(_spin["default"], {
    indicator: /*#__PURE__*/_react["default"].createElement(_LoadingOutlined["default"], {
      spin: true
    })
  });
  return /*#__PURE__*/_react["default"].createElement(RoleContext.Provider, {
    value: role
  }, children);
});

exports.RoleProvider = RoleProvider;
var _default = RoleContext;
exports["default"] = _default;